import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  ADD_MDR_SETTLEMENT,
  DEFAULT_SERVICES_MDR,
  FETCH_ALL_MERCHANT_VALIDATIONS,
  GET_ALL_MDR_BY_MID,
  GET_DEFAULT_SERVICES_MDR,
  GET_SETTLEMENT_INFO,
  UPDATE_MDR_PERCENTAGE,
} from "../../../utils/constant";
import {
  stopCharacterInput,
  stopSpecialCharacterInput,
} from "../../../utils/helper";
import swal from "sweetalert";
import ServiceCharge from "../Merchant Management/ServiceCharge";
import useApiServices from "../../../utils/useApiServices";
import SettlementForm from "../../OnBoarding/SettlementForm";

const _initialFormData = {
  settlementAccountType: "MERCHANT",
  billingMode: "POSTPAID",
  billingCycle: "daily",
  startDate: "",
  billingEndDate: "",
};

const MDRPercentage = ({ toggleRightBar, type1 }) => {
  const [settlementformData, setSettlementFormData] = useState({
    ..._initialFormData,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [merchantData, setMerchantData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [isPayoutServiceTaken, setIsPayoutServiceTaken] = useState(false);
  const [mid, setMid] = useState("");
  const [settlementType, setSettlementType] = useState("");
  const [MDRTypes, setMDRType] = useState();
  const [MDRData, setMDRData] = useState([]);
  const [activePhase, setActivePhase] = useState("Phase2");
  const { apiCallFnforGet, apiCallFnforPost, apiCallFnforPut } =
    useApiServices();

  const [defaultPayoutServicesMDR, setDefaultPayoutServicesMDR] = useState({
    mid: "",
    perTxnUpi: 0,
    perTxnImps: 0,
    perTxnRtgs: 0,
    perTxnNeft: 0,
  });

  const DefaultServicesList = [
    {
      name: "perTxnUpi",
      paymentTypeId: 1,
      paymentService: "UPI",
    },
    {
      name: "perTxnImps",
      paymentTypeId: 2,
      paymentService: "IMPS",
    },
    {
      name: "perTxnNeft",
      paymentTypeId: 3,
      paymentService: "NEFT",
    },
    {
      name: "perTxnRtgs",
      paymentTypeId: 4,
      paymentService: "RTGS",
    },
  ];

  const handleDefaultServicesMDRChange = (name, fieldName, value, mdrId) => {
    const parsedValue = parseFloat(value);

    if (stopCharacterInput(value, true) || stopSpecialCharacterInput(value)) {
      return;
    }

    // if (parsedValue < 0 || parsedValue > 100) {
    //   return;
    // }

    setDefaultPayoutServicesMDR({
      ...defaultPayoutServicesMDR,
      [name]: parsedValue,
    });
  };
  const handleChange = (e) => {
    try {
      const { name, value } = e.target;

      setSettlementFormData((prev) => {
        let updatedFormData = { ...prev };

        // Fields that should not be uppercased
        const skipUppercaseFields = [
          "billingCycle",
          "startDate",
          "billingEndDate",
          "settlementAccountType",
          "billingMode",
        ];

        // Assign updated value
        updatedFormData[name] = skipUppercaseFields.includes(name)
          ? value
          : value?.toUpperCase?.();

        // --- Unified Billing End Date Calculation ---
        if (
          (name === "startDate" || name === "billingCycle") &&
          updatedFormData.startDate &&
          updatedFormData.billingCycle
        ) {
          // Parse as local date to avoid timezone shifts
          const parts = updatedFormData.startDate.split("-");
          if (parts.length === 3) {
            const y = parseInt(parts[0], 10);
            const m = parseInt(parts[1], 10) - 1;
            const d = parseInt(parts[2], 10);
            const startDate = new Date(y, m, d);
            const endDate = new Date(startDate);

            switch (updatedFormData.billingCycle) {
              case "daily":
                endDate.setDate(startDate.getDate() + 1);
                break;
              case "weekly":
                endDate.setDate(startDate.getDate() + 7);
                break;
              case "monthly":
                endDate.setMonth(startDate.getMonth() + 1);
                break;
              case "CUSTOM":
                const dayOfMonth = startDate.getDate();
                if (dayOfMonth >= 1 && dayOfMonth <= 10) {
                  endDate.setDate(10);
                } else if (dayOfMonth >= 11 && dayOfMonth <= 20) {
                  endDate.setDate(20);
                } else {
                  // Set to last day of current month
                  endDate.setMonth(startDate.getMonth() + 1, 0);
                }
                break;
              default:
                break;
            }

            // Format back to YYYY-MM-DD local
            const ey = endDate.getFullYear();
            const em = String(endDate.getMonth() + 1).padStart(2, "0");
            const ed = String(endDate.getDate()).padStart(2, "0");
            updatedFormData.billingEndDate = `${ey}-${em}-${ed}`;
          }
        }

        return updatedFormData;
      });
    } catch (error) {
      console.log(`ERROR WHILE HANDLE CHANGE: ${error}`);
    }
  };

  const validateSettlementForm = (data) => {
    const errors = {};
    if (!data?.settlementAccountType?.trim()) {
      errors.settlementAccountType = "Settlement Account Type is required";
    }

    if (!data?.billingMode?.trim()) {
      errors.billingMode = "Billing Mode is required";
    }

    if (data?.billingMode === "POSTPAID") {
      if (!data?.billingCycle?.trim()) {
        errors.billingCycle = "Billing Cycle is required";
      }

      if (!data?.startDate?.trim()) {
        errors.startDate = "Start Date is required";
      } else {
        const selectedDate = new Date(data.startDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (selectedDate < today) {
          errors.startDate = "Start Date cannot be in the past";
        }
      }

      if (!data?.billingEndDate?.trim()) {
        errors.billingEndDate = "Billing End Date is required";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmitSettlement = async (e) => {
    e?.preventDefault();
    setIsSubmitting(true);

    if (!validateSettlementForm(settlementformData)) {
      setIsSubmitting(false);
      return;
    }

    if (!mid?.trim()) {
      swal("Error", "Please select a merchant", "error");
      setIsSubmitting(false);
      return;
    }
    // Calculate billingEndDate + 1 day
    const endDate = new Date(settlementformData?.billingEndDate);
    endDate.setDate(endDate.getDate() + 1);

    const payload = {
      settlementAccountType: settlementformData?.settlementAccountType,
      settlementMode: settlementformData?.billingMode,
      billingCycle: settlementformData?.billingCycle?.toUpperCase(),
      billingStartDate: new Date(settlementformData?.startDate).toISOString(),
      billingEndDate: endDate.toISOString(),
      mid: mid,
    };

    delete payload.startDate;
    try {
      const res = await apiCallFnforPost(ADD_MDR_SETTLEMENT, payload);
      console.log(res, "res");
      if (res?.statusCode === 200) {
        swal({
          title: "Success",
          text: "Settlement & Billing details submitted successfully!",
          icon: "success",
        });
        // handleCloseModal();
        setFormErrors({});
      } else {
        swal({
          title: "Error",
          text:
            res?.data?.message || res?.message ||
            "Failed to submit Settlement & Billing details.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Network or server error:", error);
      swal({
        title: "Error",
        text: "Something went wrong. Please try again later.",
        icon: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const getMerchantData = async () => {
    try {
      const response = await apiCallFnforGet(FETCH_ALL_MERCHANT_VALIDATIONS);
      if (response?.statusCode === 200) {
        setMerchantData(response?.data);
        console.log(response?.data);
      } else {
        setMerchantData([]);
      }
    } catch (error) {
      setMerchantData([]);
    }
  };

  useEffect(() => {
    getMerchantData();
  }, [mid]);

  const handleCompanyChange = (event) => {
    const selectedCompany = event.target.value;
    setSelectedCompany(selectedCompany);

    const selectedMerchant = merchantData.find(
      (merchant) =>
        `${merchant.prifix} :- ${merchant.mid} ${merchant.merchantName}` ===
        selectedCompany
    );

    if (selectedMerchant) {
      setMid(selectedMerchant?.mid);
      setSettlementType(selectedMerchant?.settelmentType);
      setSettlementFormData((prev) => ({
        ...prev,
        billingMode: selectedMerchant?.settelmentType || "POSTPAID",
      }));
      setDefaultPayoutServicesMDR({
        ...defaultPayoutServicesMDR,
        mid: selectedMerchant?.mid,
      });
    } else {
      setMid("");
      setSettlementType("");
      setMDRData([]);
      setMDRType([]);
    }
  };

  const fetchtheTypeOfoption = async () => {
    setMDRData([]);
    setMDRType([]);
    // if (!mid === "") {
    try {
      const MDRType = await apiCallFnforGet(GET_ALL_MDR_BY_MID + mid);
      if (MDRType?.statusCode === 200) {
        setMDRType(MDRType?.data ? MDRType?.data : []);
        setIsPayoutServiceTaken(checkIsPayoutExistInService(MDRType?.data));
      } else if (MDRType?.statusCode === 304) {
        swal({
          title: "Failed",
          text: "No details found",
          icon: "error",
        });
        setMDRType([]);
        setMid("");
        setSelectedCompany("");
      }
    } catch (error) {
      console.log(error);
    }

    // }
  };

  const fetchSettlementInfo = async () => {
    try {
      const res = await apiCallFnforGet(`${GET_SETTLEMENT_INFO}/${mid}`);

      if (res?.statusCode === 200) {
        const data = res?.data[0];
        const normalizeDate = (dateString) => dateString?.split(" ")[0] || "";
        const billingCycle =
          data?.billingCycle === "CUSTOM"
            ? "CUSTOM"
            : data?.billingCycle?.toLowerCase() || "daily";
        const startDate = normalizeDate(data?.billingStartDate);

        let billingEndDate = normalizeDate(data?.billingEndDate);

        // --- Recalculate Billing End Date if it's CUSTOM to follow UI rules ---
        if (billingCycle === "CUSTOM" && startDate) {
          const parts = startDate.split("-");
          if (parts.length === 3) {
            const y = parseInt(parts[0], 10);
            const m = parseInt(parts[1], 10) - 1;
            const d = parseInt(parts[2], 10);
            const tempDate = new Date(y, m, d);

            if (d >= 1 && d <= 10) {
              tempDate.setDate(10);
            } else if (d >= 11 && d <= 20) {
              tempDate.setDate(20);
            } else {
              tempDate.setMonth(m + 1, 0);
            }

            const ey = tempDate.getFullYear();
            const em = String(tempDate.getMonth() + 1).padStart(2, "0");
            const ed = String(tempDate.getDate()).padStart(2, "0");
            billingEndDate = `${ey}-${em}-${ed}`;
          }
        }

        // Map API fields to your form state
        setSettlementFormData({
          settlementAccountType: data?.settlementAccountType || "MERCHANT",
          billingMode: settlementType || "POSTPAID",
          billingCycle,
          startDate,
          billingEndDate,
        });
      } else {
        setSettlementFormData({ ..._initialFormData });
      }
    } catch (error) {
      console.log(error);
      setSettlementFormData({ ..._initialFormData });
    }
  };

  const fetchDefaultServicesMDR = async () => {
    setMDRData([]);
    setMDRType([]);
    // if (!mid === "") {
    try {
      const MDRType = await apiCallFnforPost(
        GET_DEFAULT_SERVICES_MDR + mid,
        ""
      );
      if (MDRType?.statusCode === 200) {
        // setIsPayoutServiceTaken(checkIsPayoutExistInService(MDRType?.data));
        const { perTxnImps, perTxnRtgs, perTxnNeft, perTxnUpi, mid } =
          MDRType?.data;
        setDefaultPayoutServicesMDR({
          perTxnImps,
          perTxnRtgs,
          perTxnNeft,
          perTxnUpi,
          mid,
        });
      } else if (MDRType?.statusCode === 304) {
        swal({
          title: "Failed",
          text: "No details found",
          icon: "error",
        });
        setIsPayoutServiceTaken(false);
        setDefaultPayoutServicesMDR({
          mid: "",
          perTxnUpi: 0,
          perTxnImps: 0,
          perTxnRtgs: 0,
          perTxnNeft: 0,
        });
        setMid("");
        setSelectedCompany("");
      }
    } catch (error) {
      console.log(error);
    }

    // }
  };

  const setMDrDataInit = (MDRTypes) => {
    MDRTypes.forEach((element) => {
      setMDRData({
        ...MDRData,
        [element.paymentTypeId]: element.mdrPercentage,
      });
    });
    setMDRData();
  };

  useEffect(() => {
    fetchtheTypeOfoption();
    fetchDefaultServicesMDR();
    fetchSettlementInfo();
  }, [mid]);

  const handleMDRChange = (value, mdrId, name) => {
    if (stopCharacterInput(value, true) || stopSpecialCharacterInput(value)) {
      return;
    }

    let data = MDRTypes.filter((elem) => {
      return elem.paymentTypeId === mdrId;
    });

    data[0].mdrPercentage = value;
    setMDRType([...MDRTypes]);
  };

  const handleMDRsubmit = async () => {
    const finalPayload = MDRTypes.map((type) => {
      return { ...type, mid: mid };
    });

    try {
      const response = await apiCallFnforPut(
        UPDATE_MDR_PERCENTAGE,
        finalPayload
      );

      // return response?.data;

      if (response.statusCode === 200) {
        // setMDRType([]);
        // setMid("");
        // setSelectedCompany("");

        swal({
          title: "Success",
          text: "Merchant discount rate updated successfully.",
          icon: "success",
        });
      } else {
        swal({
          title: "Alert!",
          text: response.message,
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  const handleDefaultServicesMDRsubmit = async () => {
    try {
      const response = await apiCallFnforPost(
        DEFAULT_SERVICES_MDR,
        defaultPayoutServicesMDR
      );

      // return response?.data;

      if (response.statusCode === 200) {
        setDefaultPayoutServicesMDR({
          mid: "",
          perTxnUpi: 0,
          perTxnImps: 0,
          perTxnRtgs: 0,
          perTxnNeft: 0,
        });
        setMid("");
        setSelectedCompany("");

        swal({
          title: "Success",
          text: "Merchant fixed charges updated successfully.",
          icon: "success",
        });
      } else {
        swal({
          title: "Alert!",
          text: response.message,
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  const checkIsPayoutExistInService = (MDRTypes) => {
    if (!MDRTypes) return false;
    const ServiceIds = MDRTypes.map((service) => {
      return service.paymentTypeId;
    });
    const ServiceNames = MDRTypes.map((service) => {
      return service.paymentService;
    });
    // alert(ServiceNames.includes("PAYOUT") && ServiceIds.includes(6))
    return ServiceNames.includes("PAYOUT") && ServiceIds.includes(6);
  };

  return (
    <>
      <div className="d-flex justify-content-between bg-white custom-card-header">
        <div className="d-flex justify-content-start align-items-center mb-4">
          <button class="btn-close m-3" onClick={toggleRightBar}></button>
          <div className="fs-2 text-dark fw-bold">Merchant Discount Rate</div>
        </div>
      </div>
      <section className="admin-dashboard-sec chargeback-reports-sec">
        <Row>
          <Col xs={12} lg={12} md={12}>
            <div>
              <div className="row">
                {activePhase === "Phase2" ? (
                  <div className="col-12 offset ">
                    <div className="col-sm-12 col-md-6  offset-md-3">
                      <label className="d-flex text-dark fs-4">
                        Select A Merchant
                      </label>

                      <select
                        id="companyDropdown"
                        className="form-control"
                        onChange={handleCompanyChange}
                        value={selectedCompany}
                      >
                        <option value="">Select a Merchant</option>
                        {merchantData?.map((merchant) => (
                          <option
                            key={merchant.mid}
                            value={`${merchant.prifix} :- ${merchant.mid} ${merchant.merchantName}`}
                          >
                            {merchant?.prifix} :- {merchant?.mid} -{" "}
                            {merchant?.merchantName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="row ">
                      <div className="col-sm-12 col-md-6 offset-md-3">
                        <div className="form-group mt-2">
                          <label className="d-flex text-dark fs-4 ">
                            Merchant MID
                          </label>
                          <input
                            required
                            type="email"
                            className="form-control "
                            id="email"
                            placeholder="Merchant ID"
                            value={mid}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <ServiceCharge data={merchantData} />
                )}
              </div>
              {activePhase === "Phase2" ? (
                // <Container>
                <Row>
                  <Col xs={12}>
                    <Row className="p-3">
                      <Col xs={12} className="mb-3">
                        <label className="mx-4 text-dark fs-4 mt-2">
                          MERCHANT DISCOUNT RATE
                          <sup className="text-danger">*</sup>
                        </label>
                        <label
                          className="fw-semi-bold text-danger"
                          style={{ fontSize: "13px" }}
                        >
                          (Please enter the MDR rate in percentage.)
                        </label>
                      </Col>

                      {mid && (
                        <SettlementForm
                          formData={settlementformData}
                          formErrors={formErrors}
                          handleSubmit={() => {
                            handleSubmitSettlement();
                          }}
                          handleChange={handleChange}
                          isSubmitting={isSubmitting}
                          settlementType={settlementType}
                        />
                      )}

                      {MDRTypes?.map((service) => (
                        <Col
                          xs={12}
                          md={4}
                          key={service.paymentTypeId}
                          className="mb-3"
                        >
                          <label className="d-flex text-dark fs-4 lh-1">
                            {service.paymentService}
                            <sup className="text-danger">*</sup>
                          </label>
                          <input
                            type="number"
                            name={service.paymentService}
                            className="form-control"
                            value={service.mdrPercentage}
                            onChange={(e) =>
                              handleMDRChange(
                                e.target.value,
                                service.paymentTypeId,
                                service.paymentService
                              )
                            }
                            required
                          />
                        </Col>
                      ))}
                      {MDRTypes?.length > 0 && (
                        <Col xs={12}>
                          <div className="d-flex justify-content-end mt-3">
                            <button
                              className="badge badge-rounded badge-primary mx-3 px-3 py-2"
                              onClick={handleMDRsubmit}
                              id="mdrSave"
                            >
                              Submit
                            </button>
                          </div>
                        </Col>
                      )}
                      {isPayoutServiceTaken && (
                        <Col xs={12} className="mb-3">
                          <label className="mx-4 text-dark fs-4 mt-2">
                            Payout
                            <sup className="text-danger">*</sup>
                          </label>
                          <label
                            className="fw-semi-bold text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            (Fixed charge per txn)
                          </label>
                        </Col>
                      )}
                      {DefaultServicesList?.map(
                        (service) =>
                          isPayoutServiceTaken && (
                            <Col
                              xs={12}
                              md={4}
                              key={service.paymentTypeId}
                              className="mb-3"
                            >
                              <label className="d-flex text-dark fs-4 lh-sm">
                                {service.paymentService}
                                <sup className="text-danger">*</sup>
                              </label>
                              <input
                                type="number"
                                name={service.name}
                                className="form-control"
                                value={defaultPayoutServicesMDR[service.name]}
                                onChange={(e) =>
                                  handleDefaultServicesMDRChange(
                                    e.target.name,
                                    service.paymentTypeId,
                                    e.target.value,
                                    service.paymentService
                                  )
                                }
                                required
                              />
                            </Col>
                          )
                      )}
                      {isPayoutServiceTaken && (
                        <Col xs={12}>
                          <div className="d-flex justify-content-end mt-3">
                            <button
                              className="badge badge-rounded badge-primary mx-3 px-3 py-2"
                              onClick={handleDefaultServicesMDRsubmit}
                              id="mdrSave"
                            >
                              Submit
                            </button>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              ) : (
                // </Container>
                ""
              )}
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default MDRPercentage;
